import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/normal-distribution-calculator',
  component: () => import('../../routes/NormalDistribution.svelte'),
  card: {
    id: 'normal-distribution-calculator',
    title: 'Normal Distribution Calculator',
    description:
      'Calculate probabilities, z-scores, and percentiles for any normal distribution. Visualize where a value falls relative to the mean.',
    icon: 'bell_curve',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/normal-distribution-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Normal Distribution Calculator – Z-Score & Probability Calculator',
    description:
      'Free normal distribution calculator to find probability, z-scores, and percentiles. Calculate P(X between a and b) for any normal distribution with known mean and standard deviation.',
  },
};

export default meta;
